import { Container, Icon, Title, Subtitle, Button } from './styles';

interface SuccessMessageProps {
  handleAccessAccount: any;
  handleGoBackAccounts: any;
}

export const SuccessMessage = ({
  handleAccessAccount,
  handleGoBackAccounts,
}: SuccessMessageProps) => {
  return (
    <Container>
      <Icon color="success" sx={{ width: '67px' }} />
      <Title>Conta/empresa criada com sucesso!</Title>
      <Subtitle>
        O usuário receberá uma notificação por e-mail para se cadastrar ou fazer
        login e aceitar o vinculo com a conta/empresa que você acabou de criar.
      </Subtitle>

      <Button variant="contained" onClick={handleAccessAccount}>
        Acessar conta
      </Button>
      <Button variant="outlined" onClick={handleGoBackAccounts}>
        Voltar para contas
      </Button>
    </Container>
  );
};
